import type { StatelessFunctionalComponent } from 'react'
import React, { Fragment } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'

type Props = {
    component: StatelessFunctionalComponent<any>,
    exact?: boolean,
    needRestaurant?: boolean,
    hasRestaurant?: boolean,
    needCollectMode?: boolean,
    hasCollectMode?: boolean,
    needCurrentOrder?: boolean,
    hasCurrentOrder?: boolean,
    needAuthentication?: boolean,
    hasAuthentication?: boolean,
    needMostRecentOrderHasBeenPaid?: boolean,
    mostRecentOrderHasbeenPaid?: boolean,
    loading?: boolean,
    location?: Object,
    path?: string,
    intl: IntlShape
}

const EcommerceRoute = (props: Props) => {
    const {
        needRestaurant,
        hasRestaurant,
        needCollectMode,
        hasCollectMode,
        needCurrentOrder,
        hasCurrentOrder,
        needAuthentication,
        hasAuthentication,
        needMostRecentOrderHasBeenPaid,
        mostRecentOrderHasbeenPaid,
        location,
        intl,
        loading,
        ...routeProps
    } = props

    return (
        <Fragment>
            {needAuthentication && needRestaurant && !hasRestaurant && (
                <Redirect
                    to={{
                        pathname: intl.formatMessage({
                            id: 'routes.clickandcollect.restaurant.choice'
                        }),
                        state: { from: location }
                    }}
                />
            )}
            {needAuthentication && needCollectMode && !hasCollectMode && (
                <Redirect
                    to={{
                        pathname: intl.formatMessage({
                            id: 'routes.clickandcollect.delivery.choice'
                        }),
                        state: { from: location }
                    }}
                />
            )}
            {needAuthentication && needCurrentOrder && !hasCurrentOrder && (
                <Redirect
                    to={{
                        pathname: intl.formatMessage({
                            id: 'routes.clickandcollect.catalog'
                        }),
                        state: { from: location }
                    }}
                />
            )}
            {needAuthentication && !hasAuthentication && (
                <Redirect
                    to={{
                        pathname: intl.formatMessage({
                            id: 'routes.signin'
                        }),
                        state: { from: location }
                    }}
                />
            )}
            {needMostRecentOrderHasBeenPaid && !mostRecentOrderHasbeenPaid && (
                <Redirect
                    to={{
                        pathname: intl.formatMessage({
                            id: 'routes.clickandcollect.cart.user.infos'
                        }),
                        state: { from: location }
                    }}
                />
            )}
            <Route {...routeProps} />
        </Fragment>
    )
}

const EcommerceRouteComponent = injectIntl(EcommerceRoute)

export { EcommerceRouteComponent }
